export const DEFAULT_CITY = 'Québec';